<svg
  width="21"
  height="20"
  viewBox="0 0 21 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10.2803 1C15.2623 1 19.2803 5.018 19.2803 10C19.2803 14.982 15.2623 19 10.2803 19M10.2803 19C5.29827 19 1.28027 14.982 1.28027 10C1.28027 5.018 5.29827 1 10.2803 1"
    stroke="#133345"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M8.44777 2.05975C5.55777 6.88475 5.55777 13.1158 8.44777 17.9408C9.29377 19.3538 11.2668 19.3538 12.1128 17.9408C15.0028 13.1158 15.0028 6.88475 12.1128 2.05975C11.2658 0.64675 9.29377 0.64675 8.44777 2.05975Z"
    stroke="#133345"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M2.29199 5.85742C7.18399 7.36842 13.38 7.36842 18.271 5.85742M18.272 14.1414C13.38 12.6304 7.18399 12.6304 2.29299 14.1414"
    stroke="#133345"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>;
import React from "react";

const Globe = ({
  width = 21,
  height = 20,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2803 1C15.2623 1 19.2803 5.018 19.2803 10C19.2803 14.982 15.2623 19 10.2803 19M10.2803 19C5.29827 19 1.28027 14.982 1.28027 10C1.28027 5.018 5.29827 1 10.2803 1"
        stroke="#133345"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.44777 2.05975C5.55777 6.88475 5.55777 13.1158 8.44777 17.9408C9.29377 19.3538 11.2668 19.3538 12.1128 17.9408C15.0028 13.1158 15.0028 6.88475 12.1128 2.05975C11.2658 0.64675 9.29377 0.64675 8.44777 2.05975Z"
        stroke="#133345"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.29199 5.85742C7.18399 7.36842 13.38 7.36842 18.271 5.85742M18.272 14.1414C13.38 12.6304 7.18399 12.6304 2.29299 14.1414"
        stroke="#133345"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Globe;
